import { BlockStack, Card, InlineStack, SkeletonBodyText, Text } from '@shopify/polaris';
import { ReactNode, memo } from 'react';

interface InfoCardProps {
  title: string;
  data?: { key: string; direction?: 'vertical' | 'horizontal'; value: ReactNode }[];
  loading?: boolean;
}

const InfoCard = ({ title, data, loading }: InfoCardProps) => {
  return (
    <Card>
      {loading ? (
        <SkeletonBodyText />
      ) : (
        <BlockStack gap="200">
          <Text as="h2" variant="headingSm">
            {title}
          </Text>
          {data && data.length > 0
            ? data.map(({ key, value, direction = 'horizontal' }, index) => {
                if (direction === 'vertical') {
                  return (
                    <BlockStack key={key} gap="100">
                      <Text as="p" variant="bodyMd">
                        {key}
                      </Text>
                      {value}
                    </BlockStack>
                  );
                }

                return (
                  <InlineStack key={key} align="space-between" gap="100" blockAlign="center">
                    <Text as="p" variant="bodyMd">
                      {key}
                    </Text>
                    {value}
                  </InlineStack>
                );
              })
            : null}
        </BlockStack>
      )}
    </Card>
  );
};

export default memo(InfoCard);
